import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import RouteList from './routes'
import NoAccess from '@/views/error/403.vue'
import NoPage from '@/views/error/404.vue'
import Layout from '@/layout/default.vue'
import Login from '@/views/login/index.vue'
import { isProdRunEnv } from '@/utils/run-env'
import { setupInterceptor } from './router.interceptor'

const aiHelperRoute: RouteRecordRaw = {
  path: '/ai-helper',
  name: 'AiHelper',
  component: () => import('@/views/efficient-office/ai-helper/ai-helper.vue'),
  meta: {
    title: 'AI 助手',
    keepAlive: true
  }
}

const loginRoute: RouteRecordRaw = {
  path: '/login',
  component: Login,
  meta: {
    keepAlive: true,
    title: '登录'
  }
}

const prodRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/ai-helper'
  },
  aiHelperRoute,
  loginRoute,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/ai-helper'
  }
]

const devRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children: RouteList
  },
  aiHelperRoute,
  loginRoute,
  {
    path: '/login2',
    component: () => import('@/views/login/ding-login.vue'),
    meta: {
      keepAlive: true,
      title: '钉钉登录'
    }
  },
  {
    path: '/app-download',
    name: 'appDownload',
    component: () => import('@/views/app-download/index.vue'),
    meta: {
      title: '应用下载',
      keepAlive: false
    }
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/views/demo.vue'),
    meta: {
      title: '测试'
    }
  },
  {
    path: '/resign-download',
    name: 'resignDownload',
    component: () => import('@/views/resign-download/index.vue'),
    meta: {
      title: '重签名应用下载',
      keepAlive: false
    }
  },
  {
    path: '/403',
    component: NoAccess,
    meta: {
      keepAlive: true,
      title: '访问拒绝'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    component: NoPage,
    meta: {
      keepAlive: true,
      title: '找不到页面'
    }
  }
]

const routes = isProdRunEnv ? prodRoutes : devRoutes

const router = createRouter({
  history: createWebHistory('/pc/'),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        left: 0,
        top: 0
      }
    }
  }
})

setupInterceptor(router)

export default router
